import { Col } from '@/app/components/Flex/Flex'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { useNavigate } from '@/app/hooks/useNavigate'
import type { FunctionalComponent } from 'preact'

export const BirthRequired: FunctionalComponent<{
  onClose: () => void
}> = props => {
  const route = useNavigate()

  return (
    <UI.Popup
      onClose={props.onClose}
    >
      <Lib.PopupHeader>
        Уточни данные
      </Lib.PopupHeader>

      <Lib.PopupMessage>
        Чтобы точно рассчитать этот раздел натальной карты, нужны время и место рождения. Их можно добавить в настройках профиля.
      </Lib.PopupMessage>

      <Col grid gap={15}>
        <UI.Button
          size='m'
          type='secondary'
          onClick={props.onClose}
        >
          Позже
        </UI.Button>
        <UI.Button
          size='m'
          type='primary'
          onClick={() => {
            props.onClose()
            route('~/settings')
          }}
        >
          Заполнить
        </UI.Button>
      </Col>
    </UI.Popup>
  )
}
